import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import TPGrid from 'components/TP-UI/TPGrid';
import PropTypes from 'prop-types';
import TPCardAvatar from 'components/TP-UI/TPCard/components/TPCardAvatar';
import TPCard from 'components/TP-UI/TPCard';
import TPCardContent from 'components/TP-UI/TPCard/components/TPCardContent';
import TPCardTitle from 'components/TP-UI/TPCard/components/TPCardTitle';
import TPCardDescription from 'components/TP-UI/TPCard/components/TPCardDescription';
import { MFA_TYPE, MFA_TYPE_OPTIONS } from '../../../../constants';
import TPErrorMessage from 'components/TP-UI/TPErrorMessage';

import useStyles from './styles.js';

export const MfaTypes = ({ value = '', error, allowedTypes = [], onChange }) => {
  const classes = useStyles();
  const { t } = useTranslation('auth');
  const mfaOptions = useMemo(
    () => MFA_TYPE_OPTIONS.filter((opt) => allowedTypes?.includes(opt.value)),
    [allowedTypes],
  );

  const displayedMfaOptions = useMemo(() => {
    let opts = [...mfaOptions];
    const opt = MFA_TYPE_OPTIONS.find((opt) => opt.value === value);
    if (value && !allowedTypes?.includes(value) && opt) {
      opts = [{ ...opt, disabled: true }];
    }
    return opts;
  }, [mfaOptions, allowedTypes, value]);

  return (
    <TPGrid item container spacing={2}>
      {error && (
        <TPGrid item xs={12}>
          <TPErrorMessage error={error} size="medium" />
        </TPGrid>
      )}
      {displayedMfaOptions.map(({ icon: Icon, ...option }) => (
        <TPGrid item xs={12} key={option.value}>
          <TPCard
            onClick={() => onChange(option.value)}
            fullWidth
            disabled={option.disabled}
            selected={value === option.value}>
            <TPCardContent>
              <TPGrid container spacing={1} wrap="nowrap">
                <TPGrid item>
                  <TPCardAvatar primary size={32}>
                    <Icon fontSize="small" />
                  </TPCardAvatar>
                </TPGrid>
                <TPGrid item>
                  <TPCardTitle gutterBottom className={classes.title}>
                    {t(option.label)}
                  </TPCardTitle>
                  <TPCardDescription>{t(option.description)}</TPCardDescription>
                </TPGrid>
              </TPGrid>
            </TPCardContent>
          </TPCard>
        </TPGrid>
      ))}
    </TPGrid>
  );
};

MfaTypes.propTypes = {
  value: PropTypes.oneOf([...Object.values(MFA_TYPE), '']),
  allowedTypes: PropTypes.array,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func.isRequired,
};

const ReduxMfaTypes = ({ input, meta, ...others }) => {
  const error = meta.submitFailed && meta.error ? meta.error : null;
  const { onChange } = input;
  return <MfaTypes {...input} error={error} {...others} onChange={onChange} />;
};

export default ReduxMfaTypes;
